const base = {
  default: {
    '& > li': {
      '& > [data-link-as-button="true"]': {
        margin: 0
      }
    },
    ['@media (max-width: 1000px)']: {
      '&.isExpanded': {
        position: 'relative',
        display: 'block',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: 'coolGrey.10'
      }
    }
  }
};

const press = {
  default: {
    flex: 1,
    order: 0,
    minHeight: '64px',
    justifyContent: 'flex-start',
    margin: 0,
    ['@media (max-width: 1023px)']: {
      '&.isExpanded': {
        position: 'relative',
        display: 'block',
        border: 0
      }
    },
    ['@media (max-width: 1100px)']: {
      display: 'none'
    }
  }
};

const innerContainer = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    press,
    spark: base
  }
};

export default innerContainer;
